// extracted by mini-css-extract-plugin
export default {"PfsPIIB":"PFSPIIB_PfsPIIB__Gtb3U","content":"PFSPIIB_content__3JJre","homeBtn":"PFSPIIB_homeBtn__8jRJO","logo":"PFSPIIB_logo__npZ73"};